export const uk = {
    'drop-files-here': 'Перетащите файлы с баннерами сюда',
    'press-upload': 'или нажмите «Загрузить». Перед загрузкой посмотрите {requirementsLink}',
    requirements: 'технические требования',
    upload: 'Загрузить'
};
